module.exports = __webpack_public_path__ + "img/pic_5.7eddc64b.png";